var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileBvhelobx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.111 4.111a3.111 3.111 0 11-6.222 0 3.111 3.111 0 016.222 0zM8 9.5c-3.007 0-6 2.493-6 5.5h12c0-3.007-2.993-5.5-6-5.5z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjExMTEgNC4xMTExMUMxMS4xMTExIDUuODI5MzMgOS43MTgxOSA3LjIyMjIyIDggNy4yMjIyMkM2LjI4MTc4IDcuMjIyMjIgNC44ODg4OSA1LjgyOTMzIDQuODg4ODkgNC4xMTExMUM0Ljg4ODg5IDIuMzkyODkgNi4yODE3OCAxIDggMUM5LjcxODE5IDEgMTEuMTExMSAyLjM5Mjg5IDExLjExMTEgNC4xMTExMVpNOCA5LjVDNC45OTMxMiA5LjUgMiAxMS45OTMxIDIgMTVIMTRDMTQgMTEuOTkzMSAxMS4wMDY5IDkuNSA4IDkuNVoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgProfileBvhelobx as ReactComponent };